// extracted by mini-css-extract-plugin
export default {"item":"SidebarItem_item__TCKaQ","active":"SidebarItem_active__ewsAQ","icon":"SidebarItem_icon__MRhlN","label":"SidebarItem_label__v-XQv"};